export class paginationDTO {
  pageNo: number;
  pageSize: number;
  search: string;
  sortBy: string;
  sortDirection: string;
}
